exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text[data-v-1f127a69] {\n  padding: 20px 0;\n  text-align: center;\n  font-size: 16px;\n  font-weight: bold;\n}\n", ""]);

// exports
